// Lazy load function
const lazyLoad = (file) => () =>
  import(
    /* webpackChunkName: "[request]" */ `@/views/production/planning/${file}.vue`
  );

export default [
  {
    path: "/production-planning",
    name: "production-planning",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionPlanning",
    },
    components: {
      content: lazyLoad("production-planning"),
    },
  },
];
